
    import './styles.scoped.css';
    export default {
  "modal-actions": "awsui_modal-actions_12hyz_xhta6_181",
  "submit-button": "awsui_submit-button_12hyz_xhta6_185",
  "last-updated-caption": "awsui_last-updated-caption_12hyz_xhta6_189"
};
  